type RemoveBrandPrefixParameters = {
  brand: string;
  text: string;
  fitIndicators?: readonly string[] | string[];
};

const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const getFitIndicatorSuffix = (
  brand: string,
  fitIndicators: readonly string[],
): string | null => {
  const found = fitIndicators.find((indicator) =>
    new RegExp(`\\b${escapeRegExp(indicator)}$`, "i").test(brand),
  );

  return found ?? null;
};

const stripPrefix = (brand: string, text: string): string => {
  const regex = new RegExp(`^${escapeRegExp(brand)}\\s*(\\w)`, "i");
  return text.replace(regex, (_, firstLetter) => firstLetter.toUpperCase());
};

export const removeBrandPrefix = ({
  brand,
  text,
  fitIndicators = [],
}: RemoveBrandPrefixParameters): string => {
  if (!brand) {
    return text;
  }

  const fitIndicator = getFitIndicatorSuffix(brand, fitIndicators);

  if (fitIndicator) {
    const coreBrand = brand.slice(0, brand.length - fitIndicator.length).trim();

    if (!coreBrand) {
      return text;
    }

    return stripPrefix(coreBrand, text);
  }

  return stripPrefix(brand, text);
};
